import { FC, useState } from 'react';
import theme from 'config/theme';
import { Row } from 'components/Row';
import { Link } from 'components/Link';
import { Body, BodySmall, UtilityText } from 'components/Typography';
import { formatNumberAsCurrency, getPathWithRef } from 'helpers/utils';
import {
  FormPage,
  FormStyled,
  NavigationAmountDetails,
  NavigationContainer,
  NextPrevLink,
  OlNavigation,
  ProgressBar,
} from 'screens/Checkout/styled';
import { getUrlSearchParamsStrWithoutRecipients } from 'helpers/donate';
import { PersonalDetails } from './PersonalDetails';
import { Form } from 'react-final-form';
import { IUserData } from 'store/user/types';
import Icon, { IconNames } from 'components/Icon';
import Spacing from 'components/Spacing';
import { SubmitButtonContainer } from './SubmitButtonContainer';
interface Props {
  chariotConnectId?: string | false | undefined;
  chariotDetailsReady: boolean;
  donationAmount: number;
  getOnDonationRequest: (valid: boolean) => () => object;
  onChariotDonateSuccess: (response: any) => void;
  onSubmit: (formValues: any) => Promise<any>;
  user?: IUserData;
}

export const CheckoutForm: FC<Props> = ({
  chariotConnectId,
  chariotDetailsReady,
  donationAmount,
  getOnDonationRequest,
  onChariotDonateSuccess,
  onSubmit,
  user,
}) => {
  const [activePageIndex, setActivePageIndex] = useState(0);
  const formPages = [
    {
      navigationTitle: '2. Details',
    },
    {
      navigationTitle: '3. Confirm',
    },
  ];

  const initialValues = {
    email: user?.email || '',
    first_name: user?.first_name || '',
    last_name: user?.last_name || '',
  };

  return (
    <>
      <Row>
        <NavigationContainer $justifyContent="space-between">
          <OlNavigation>
            <li>
              <Link to={getPathWithRef(`/donate?${getUrlSearchParamsStrWithoutRecipients()}`)}>
                <BodySmall $fontType="semiBold" $color={theme.colors.inkBlue}>
                  1. Amount
                </BodySmall>
                <NavigationAmountDetails $fontType="semiBold" $color={theme.colors.inkBlue}>
                  {` (${formatNumberAsCurrency(donationAmount)})`}
                </NavigationAmountDetails>
              </Link>
            </li>
            {formPages.map(({ navigationTitle }, index) => (
              <li key={index}>
                <button
                  onClick={() => index < activePageIndex && setActivePageIndex(index)}
                  disabled={index >= activePageIndex}
                >
                  <BodySmall
                    $fontType={index <= activePageIndex ? 'semiBold' : 'regular'}
                    $color={
                      index <= activePageIndex ? theme.colors.inkBlue : theme.shadows.black(0.7)
                    }
                  >
                    {navigationTitle}
                  </BodySmall>
                </button>
              </li>
            ))}
          </OlNavigation>
          <ProgressBar $width="50%" />
        </NavigationContainer>
      </Row>
      <div>
        <Body $color={theme.colors.black}>Complete your </Body>
        <Body $fontType="semiBold" $color={theme.colors.black}>
          {formatNumberAsCurrency(donationAmount)} contribution:
        </Body>
      </div>
      <Form initialValues={initialValues} onSubmit={onSubmit}>
        {({ handleSubmit, submitting, submitError, valid, form }) => (
          <FormStyled onSubmit={handleSubmit}>
            <div>
              <Row $alignItems="center">
                <Icon name={IconNames.ChevronLeft} color={theme.colors.gray} size={8} />
                <Spacing $isVertical $size={4} />
                <NextPrevLink
                  to={getPathWithRef(`/donate?${getUrlSearchParamsStrWithoutRecipients()}`)}
                >
                  <BodySmall>Previous</BodySmall>
                </NextPrevLink>
              </Row>
              <FormPage>
                <PersonalDetails isLoggedIn={!!user?.id} />
                <SubmitButtonContainer
                  chariotConnectId={chariotConnectId}
                  onDonationRequest={getOnDonationRequest(valid || !!submitError)}
                  onChariotDonateSuccess={onChariotDonateSuccess}
                  valid={valid}
                  submitting={submitting}
                  submitError={submitError}
                  isSubmitReady={valid && chariotDetailsReady}
                  submit={form.submit}
                />
              </FormPage>
              <UtilityText $color={theme.shadows.black(0.6)}>
                *All fields are required unless otherwise noted.
              </UtilityText>
            </div>
          </FormStyled>
        )}
      </Form>
    </>
  );
};
